module.exports = __webpack_public_path__ + "img/logo.4d7f8ef4.svg";